import React from 'react';

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero__bg">
        <div className="hero__grid" />
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
      </div>

      <div className="container hero__content">
        <div className="hero__badge">
          <span className="hero__badge-dot" />
          UK-Based &middot; AI-Powered &middot; AWS Cloud
        </div>

        <h1 className="hero__title">
          Building the Future of
          <span className="gradient-text"> Mobile Experiences</span>
        </h1>

        <p className="hero__subtitle">
          We craft intelligent iOS and Android applications that put consumers first.
          Powered by artificial intelligence and built on AWS cloud infrastructure,
          our apps deliver experiences that feel like magic.
        </p>

        <div className="hero__actions">
          <a href="#contact" className="btn btn--primary btn--large">
            Start Your Project
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4 10h12m0 0l-4-4m4 4l-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a href="#services" className="btn btn--outline btn--large">
            Our Services
          </a>
        </div>

        <div className="hero__stats">
          <div className="hero__stat">
            <span className="hero__stat-number">AI</span>
            <span className="hero__stat-label">Powered Apps</span>
          </div>
          <div className="hero__stat-divider" />
          <div className="hero__stat">
            <span className="hero__stat-number">iOS + Android</span>
            <span className="hero__stat-label">Cross-Platform</span>
          </div>
          <div className="hero__stat-divider" />
          <div className="hero__stat">
            <span className="hero__stat-number">AWS</span>
            <span className="hero__stat-label">Cloud Native</span>
          </div>
        </div>
      </div>

      <div className="hero__scroll">
        <span>Scroll to explore</span>
        <div className="hero__scroll-line" />
      </div>
    </section>
  );
};

export default Hero;
